import React from 'react';
import FiltersContext from './FiltersContext';
import CheckboxerContext from './Checkboxer/CheckboxerContext';

interface IProps {
  children: React.ReactNode,
}

const FiltersContextWrapper = ({ children }: IProps) => {
  return (
    <FiltersContext>
      <CheckboxerContext>
        { children }
      </CheckboxerContext>
    </FiltersContext>
  );
};

export default FiltersContextWrapper;
